* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 100%;
  height: 100%;
}

.wrapper {
  height: 100%;

  .loading-container {
    display: none;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;

    gz-progress-spinner {
      display: flex;
      justify-content: center;
    }
  }

  .policy-panel-error {
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 100%;

    gz-image-repo {
      width: 500px;
      height: auto;
    }
  }

  &.is-error, &.is-loading {
    gz-searchable-policy-panel-view {
      display: none;
    }
  }

  &:not(.is-error):not(.is-loading) {
    gz-searchable-policy-panel-view {
      display: flex;
      height: 100%;
      align-items: stretch;
    }
  }

  &.is-error {
    .policy-panel-error {
      display: flex;
    }
  }

  &:not(.is-error) {
    .policy-panel-error {
      display: none;
    }
  }

  &:not(.is-loading) {
    .loading-container {
      display: none;
    }
  }

  &.is-loading {
    .loading-container {
      display: flex;
    }
  }
}
